angular.module('stack.common.i18n.filters.localize', [
  'stack.common.i18n.models.TranslationModel'
])

/**
 * The Localize filter translates a string using a translation map
 * and injects it into the element. This method is processor-intensive
 * and should be used sparingly. If possible, leverage the stackLocalize
 * directive instead.
 *
 * @class Localize
 * @constructor
 * @module stack.common.i18n.filters.localize
 * @example
 *   // The Localize filter should be placed within a template.
 *   {{"BUTTON_SIGNIN" | localize}}
 */
.filter('localize', [
  'TranslationModel',
  function (TranslationModel) {
    'use strict';

    return function (input) {
      var map = TranslationModel.getCache();
      var translated = input;

      if (angular.isDefined(map) && angular.isObject(map) && _.has(map, input)) {
        translated = map[input];
      }

      return translated;
    };
  }
]);
